import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Send the fc_session cookie (HttpOnly, set by the backend on login) on
// every request - required now that authentication is a real server-side
// session rather than a client-supplied user_slug (see backend FC-05 fix).
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

serviceWorkerRegistration.register();
